import Header from "./components/Header";
import SliderSingle from "./blocks/bloc_slider_single_type3";
import SliderHeader from "./blocks/bloc_slider_header";
import Video from "./blocks/bloc_video";
import Accordion from "./blocks/bloc_accordeon";
import Organisation from "./blocks/bloc_organisation";
import Timeline from "./blocks/bloc_timeline";
import WorldMap from "./blocks/bloc_map";
// import Form from "./components/Form";
// import Select from "./components/Select";
import AnimGsap from "./utils/anim-gsap";


const main = {
    init: function () {
        Header.init();
        SliderSingle.init();
        SliderHeader.init();
        Video.init();
        Accordion.init();
        Organisation.init();
        // Select.init();
        // Form.init();
        AnimGsap.init();
        Timeline.init();
        WorldMap.init();
    }
};

export default main